// extracted by mini-css-extract-plugin
export default {"root":"DayPicker_root__Vk3Qm","fullText":"DayPicker_fullText__X4qsl","shortText":"DayPicker_shortText__avub4","active":"DayPicker_active__tkHbc"};